/**
 * 加密保存：对字符串进行 Base64 编码 + 时间戳混淆
 * 支持中文
 */
export const encrypt = (data) => {
  const timestamp = Date.now();
  const mixed = `${data}|${timestamp}`; // 拼接数据和时间戳
  return btoa(unescape(encodeURIComponent(mixed))); // 中文兼容的 Base64 编码
};

/**
 * 解密读取：解码并返回原始数据（去掉时间戳）
 */
export const decrypt = (encoded) => {
  try {
    const decoded = decodeURIComponent(escape(atob(encoded)));
    return decoded.split('|')[0]; // 返回 | 之前的数据（原始内容）
  } catch (e) {
    console.warn('解密失败', e);
    return '';
  }
};
